export const SR_CONTENT = {
  hero: {
    kicker: 'Para representantes comerciais e vendedores externos',
    title: 'Sua comissão ainda é calculada na planilha, com atraso e sem confiança? Isso tem solução.',
    subtitle:
      'Tenha sua carteira de clientes protegida, gere proposta em PDF no atendimento e veja sua comissão calculada automaticamente a cada venda fechada.',
    cta: 'Quero minha comissão automática',
    ctaMessage: 'Quero conhecer o sistema para representante comercial do 77Gestão',
    urgency: 'Cada venda fechada sem sistema é mais uma comissão para conferir na mão, com atraso, no fim do mês.',
  },

  statsStrip: [
    { number: 'Automático', label: 'cálculo de comissão por venda', icon: 'fa-solid fa-calculator' },
    { number: '1 carteira', label: 'de clientes só sua, sem mistura', icon: 'fa-solid fa-user-lock' },
    { number: 'No atendimento', label: 'proposta em PDF pronta para o cliente', icon: 'fa-solid fa-file-pdf' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações na sua rotina de representante?',
    intro:
      'Quem vive de comissão sabe: cada erro de cálculo ou cliente disputado com outro vendedor é dinheiro e confiança que se perdem.',
    items: [
      { icon: 'fa-solid fa-table-cells', text: 'Comissão calculada manualmente, com atraso, e você só descobre o valor quando o financeiro finalmente fecha a conta.' },
      { icon: 'fa-solid fa-users-rectangle', text: 'Sua carteira de clientes se mistura com a de outros vendedores da equipe, e mais de um representante disputa a mesma venda.' },
      { icon: 'fa-solid fa-file-circle-exclamation', text: 'Orçamento feito em campo, no papel ou de improviso, sem padrão — e o cliente não leva nada formal para decidir.' },
      { icon: 'fa-regular fa-clock', text: 'Você não sabe, no meio do mês, quanto já gerou de comissão até aquele momento.' },
      { icon: 'fa-solid fa-route', text: 'A origem da venda (indicação, prospecção própria, canal) não fica registrada em lugar nenhum.' },
    ],
  },

  midCta: {
    text: 'E se cada venda fechada já saísse com a comissão calculada e a proposta em PDF pronta na hora do atendimento?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema para representante comercial do 77Gestão',
  },

  solution: {
    title: 'Sua carteira, sua proposta e sua comissão, sob seu controle.',
    intro:
      'O 77Gestão dá ao representante comercial e ao vendedor externo uma carteira protegida, proposta profissional e comissão calculada sozinha.',
    cards: [
      {
        icon: 'fa-solid fa-user-lock',
        title: 'Carteira de clientes restrita por vendedor',
        text: 'Seus clientes ficam vinculados a você no sistema, evitando que outro vendedor da equipe dispute a mesma conta.',
      },
      {
        icon: 'fa-solid fa-file-pdf',
        title: 'Proposta em PDF direto no atendimento',
        text: 'Gere a proposta comercial em PDF na hora, com aparência profissional, sem depender de modelo solto ou planilha.',
      },
      {
        icon: 'fa-solid fa-calculator',
        title: 'Comissão calculada automaticamente',
        text: 'Assim que a venda é fechada, a comissão já é calculada — sem esperar o fechamento do mês para saber quanto vai receber.',
      },
      {
        icon: 'fa-solid fa-route',
        title: 'Canais de negociação registrados',
        text: 'Registre a origem de cada venda (canal de negociação) e tenha clareza de onde seus resultados estão vindo.',
      },
      {
        icon: 'fa-solid fa-address-book',
        title: 'Histórico completo do cliente',
        text: 'Acesse o histórico de propostas e vendas de cada cliente da sua carteira antes de qualquer nova negociação.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando o representante para de depender do financeiro para saber sua comissão',
    intro:
      'Um representante comercial com carteira própria de mais de 40 clientes fechava vendas em campo e só sabia sua comissão exata quando o financeiro da empresa terminava de conferir tudo, semanas depois.',
    stats: [
      { number: '0', label: 'disputas de carteira com outros vendedores' },
      { number: 'Na hora', label: 'proposta em PDF pronta para o cliente' },
      { number: 'Automático', label: 'valor de comissão por venda fechada' },
    ],
    paragraphs: [
      'Depois de passar a usar o sistema, cada venda fechada em campo já saiu com a comissão calculada, vinculada à carteira protegida do representante.',
      'A proposta em PDF, gerada no próprio atendimento, deu mais confiança ao cliente e agilizou o fechamento — sem depender de modelo improvisado.',
    ],
    highlight: 'Resultado: comissão sem espera, carteira protegida e proposta profissional em qualquer atendimento.',
    cta: 'Quero esse nível de controle',
    ctaMessage: 'Vi o resultado e quero entender como ter minha comissão automática no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam a rotina do representante comercial',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Comissão de cada venda disponível assim que ela é fechada, sem esperar o fechamento do mês.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Carteira de clientes restrita a você, sem mistura com a de outros vendedores da equipe.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Histórico de propostas e vendas por cliente ajuda a planejar a próxima negociação com mais segurança.',
      },
    ],
  },

  differentials: {
    title: 'Por que representantes comerciais escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-link', text: 'Carteira de clientes, proposta e comissão integradas — um lançamento alimenta tudo.' },
      { icon: 'fa-solid fa-file-pdf', text: 'Proposta em PDF gerada no próprio atendimento, sem depender de outro programa.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: você começa a usar com sua carteira já organizada no sistema.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'A empresa toda usa o mesmo sistema. Minha carteira fica exposta para outros vendedores?',
        answer:
          'Não. A carteira de clientes é restrita por vendedor dentro do sistema — cada representante vê e negocia apenas com os clientes vinculados a ele.',
      },
      {
        question: 'Consigo gerar a proposta na hora, durante uma visita?',
        answer:
          'Sim. A proposta comercial é gerada em PDF direto no atendimento, com os itens e valores da negociação, pronta para enviar ou entregar ao cliente.',
      },
      {
        question: 'Como sei quanto vou receber de comissão sem esperar o financeiro fechar o mês?',
        answer:
          'A comissão é calculada automaticamente a cada venda fechada, então você tem visibilidade do valor gerado sem depender do fechamento mensal.',
      },
      {
        question: 'Dá para saber de onde veio cada venda, tipo indicação ou prospecção própria?',
        answer:
          'Sim. Os canais de negociação registram a origem de cada venda, dando clareza sobre de onde seus resultados estão vindo.',
      },
      {
        question: 'Sou representante autônomo, não tenho uma empresa grande por trás. Consigo usar?',
        answer:
          'Sim. O sistema se adapta tanto a um representante individual quanto a uma equipe de vendedores externos com carteiras próprias.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de esperar o financeiro para saber sua comissão. Tenha o número na hora que a venda fecha.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como proteger sua carteira, gerar propostas em PDF e calcular sua comissão automaticamente.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema para representante comercial do 77Gestão',
  },

  seo: {
    title: 'Sistema para Representante Comercial — Comissão Automática | 77Gestão',
    description:
      'Software de comissão para vendedor externo e representante comercial: carteira de clientes protegida, proposta em PDF no atendimento e comissão calculada automaticamente. Agende uma demonstração.',
  },
};
